import { render, staticRenderFns } from "./SelectCMS.vue?vue&type=template&id=5a057a23&scoped=true&"
import script from "./SelectCMS.vue?vue&type=script&lang=js&"
export * from "./SelectCMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a057a23",
  null
  
)

export default component.exports